import { useNotify, useRecordContext, useRefresh } from "react-admin";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Button, Tooltip } from "@mui/material";

import ConfirmModal from "server/components/Modals/ConfirmModal";
import { erasmusRequests } from "api/erasmusApi";
import { ErasmusApplicationStatuses } from "utils/constants";
import dataProvider from "server/dataProvider";

const LABEL = "Приключи мобилност";

const CompleteMobilityDialog = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  // terminal transition — reachable only from GradesEntered
  if (!record || record.status !== ErasmusApplicationStatuses.GradesEntered) return null;

  if (!record.absenceStartDate || !record.absenceEndDate) {
    return (
      <Tooltip title="Задайте период на отсъствие, за да приключите мобилността.">
        {/* the disabled button has pointer-events: none, so the span must carry the hover area */}
        <span>
          <Button
            sx={{ width: "max-content" }}
            variant="contained"
            size="medium"
            startIcon={<CheckCircleIcon />}
            disabled
          >
            {LABEL}
          </Button>
        </span>
      </Tooltip>
    );
  }

  const handleConfirm = async () => {
    await dataProvider.customRequest(erasmusRequests.completeApplication(record.id), null, "PUT");

    notify("Мобилността е приключена успешно.", { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      titleContent="Приключване на мобилност"
      message="Сигурни ли сте, че искате да приключите мобилността? Действието е необратимо и заключва редакцията на транспорта и периода на отсъствие."
      onConfirm={handleConfirm}
      titleButton={LABEL}
      startIcon={<CheckCircleIcon />}
      btnStyle={{ width: "max-content" }}
      saveTitle="Приключи"
      closeTitle="Откажи"
    />
  );
};

export default CompleteMobilityDialog;
